import * as D from '@radix-ui/react-dialog'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export type DrawerSize = 'nav' | 'sm' | 'md' | 'lg' | 'xl'

const SIZES: Record<DrawerSize, string> = {
  nav: 'w-72',
  sm: 'w-full max-w-md',
  md: 'w-full max-w-lg',
  lg: 'w-full max-w-xl',
  xl: 'w-full max-w-2xl',
}

type DrawerProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  side?: 'left' | 'right'
  size?: DrawerSize
  className?: string
  children: ReactNode
}

export function Drawer({ open, onOpenChange, title, side = 'left', size = 'nav', className, children }: DrawerProps) {
  return (
    <D.Root open={open} onOpenChange={onOpenChange}>
      <D.Portal>
        <D.Overlay className="fixed inset-0 z-40 animate-overlay-in bg-black/60 backdrop-blur-[3px] dark:bg-black/70" />
        <D.Content
          aria-describedby={undefined}
          className={cn(
            'fixed inset-y-0 z-50 flex flex-col bg-card focus:outline-none',
            SIZES[size],
            side === 'left' ? 'left-0 border-r' : 'right-0 border-l',
            size === 'nav' && 'bg-sidebar',
            className,
          )}
        >
          <D.Title className="sr-only">{title}</D.Title>
          {children}
        </D.Content>
      </D.Portal>
    </D.Root>
  )
}
